import React from 'react';
import gmLogoName from '../../assets/gmLogoName.png';

function PaywallComponent({
    onClose
}) {
    const handleGetAccessClick = () => {
        window.open('https://satodadj.gumroad.com/l/rlqzat', '_blank');
    };

    return (
        <div className='fixed inset-0 flex flex-col justify-center bg-gray-100 bg-opacity-80 backdrop-blur-md p-4 sm:p-8 md:p-16 rounded-lg' style={{ zIndex: 2147483647 }}>
            <div>            
                <button 
                    className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 font-bold py-2 px-3 sm:px-4 rounded text-sm sm:text-base"
                    onClick={onClose}
                >
                    Close
                </button>
                <img src={gmLogoName} alt="GM Logo" className="w-32 sm:w-40 mx-auto mt-2 sm:mt-4 mb-2" />
                <p className="text-center text-md sm:text-xl md:text-2xl mt-4 sm:mt-8 py-2 sm:py-4 md:py-0 px-2">You need a Premium plan to access this functionality.</p>                 
            </div>
            
            <div className="flex flex-col md:flex-row items-center md:items-stretch
                px-4 sm:px-8 md:px-0 
                space-y-4 sm:space-y-8 md:space-y-0
                overflow-y-auto md:overflow-y-hidden  
                justify-center 
                items-center 
                md:space-x-16 
                mt-4 sm:mt-8
                py-2 sm:py-5">
                <div className="bg-white w-full md:w-2/5 flex flex-col h-full p-4 sm:p-6 md:p-8 mt-24 sm:mt-0 rounded-lg shadow-xl">
                    <h2 className="text-lg sm:text-xl font-bold text-center">Base Plan</h2>
                    <p className="text-center text-xs mt-2 text-gray-500">For those getting started with GrantMagic</p>
                    <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-left mt-2">Free</p>
                    <p className="text-left text-xs sm:text-sm mt-2 text-gray-500">In your spare time, find possible funders</p>
                    <hr className="my-2 border-t border-gray-200 w-full" />                                                            
                    <ul className="text-left text-xs sm:text-sm mt-4 space-y-1 sm:space-y-2">
                        <li>✅ Limited access to grant database (last 3 months)</li>
                        <li>❌ No AI-powered grant discovery emails</li>
                        <li>❌ No AI grant writing (LOIs, cover letters, etc.)</li>                                                                    
                        <li>❌ No ability to manage multiple programs</li>                        
                    </ul>
                    <button className="bg-gray-200 text-white font-bold py-2 px-4 rounded mt-4 sm:mt-6 w-full mb-2 sm:mb-4 cursor-not-allowed text-sm sm:text-base">Already Joined</button>
                </div>
                <div className="bg-white w-full md:w-2/5 flex flex-col h-full p-4 sm:p-6 md:p-8 rounded-lg shadow-xl">
                    <h2 className="text-lg sm:text-xl font-bold text-center">Premium Plan</h2>
                    <p className="text-center text-xs mt-2 text-gray-500">For nonprofits ready to win more grant funding</p>
                    <p className="text-left mt-4"><span className="text-2xl sm:text-3xl md:text-4xl font-bold">$5 / month</span><span className="text-xs ml-2 text-left mt-2 text-gray-500">(billed annually)</span></p>
                    
                    <p className="text-left text-xs sm:text-sm mt-2 text-gray-500">Win more grants, for the price of a latte</p>
                    <hr className="my-2 border-t border-gray-200 w-full" />    
                    <ul className="text-left text-xs sm:text-sm mt-4 space-y-1 sm:space-y-2">
                        <li>✅ Full access to grant database (millions of awards)</li>
                        <li>✅ AI grant discovery emails with funder analysis</li>
                        <li>✅ AI-generated first drafts (LOIs, cover letters, etc.)</li>                                                                                                                      
                        <li>✅ Create / manage multiple grant-seeking programs</li>          
                    </ul>                                                        
                    <button className="bg-indigo-500 text-white font-bold py-2 px-4 rounded mt-4 sm:mt-6 w-full text-sm sm:text-base hover:bg-indigo-600" onClick={handleGetAccessClick}>Get Access Now</button>
                </div>
            </div>
            
        </div>                    
  );
}

export default PaywallComponent;
